import { useNavigate, useParams } from 'react-router';
import './PaymentPage.scss';
import { useEffect, useState } from 'react';
import PaymentSuccess from './PaymentSuccess';
import PaymentFailed from './PaymentFailed';
import PaymentPending from './PaymentPending';
import Loader from '../Loader/Loader';

const apiUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '');

const PaymentStatus = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [status, setStatus] = useState<
    'LOADING' | 'SUCCESS' | 'FAILURE' | 'PENDING' | 'ERROR'
  >('LOADING');

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      if (!orderId) {
        setStatus('FAILURE');
        return;
      }

      if (!apiUrl) {
        console.error('REACT_APP_API_URL is not configured.');
        setStatus('FAILURE');
        return;
      }

      try {
        const url = `${apiUrl}/payment/phonepe/status/${encodeURIComponent(orderId)}`;

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });

        const rawText = await response.text();
        let data: any = rawText ? JSON.parse(rawText) : {};

        const paymentState =
          data?.state ??
          data?.data?.state ??
          data?.status ??
          data?.paymentState ??
          '';

        if (!response.ok && !paymentState) {
          setStatus('FAILURE');
          return;
        }

        if (paymentState === 'COMPLETED' || paymentState === 'SUCCESS') {
          setStatus('SUCCESS');
        } else if (paymentState === 'PENDING') {
          setStatus('PENDING');
        } else {
          setStatus('FAILURE');
        }
      } catch (error) {
        console.error('Payment status fetch failed:', error);
        setStatus('FAILURE');
      }
    };

    void fetchPaymentStatus();
  }, [orderId]);

  return (
    <>
      {status === 'SUCCESS' ? (
        <PaymentSuccess />
      ) : status === 'PENDING' ? (
        <PaymentPending />
      ) : status === 'FAILURE' ? (
        <PaymentFailed />
      ) : (
        <Loader isHomeLoader={true} />
      )}
    </>
  );
};

export default PaymentStatus;
